export const DEFAULT_REGION = 'europe-west1';
